import React from 'react';

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
  format?: boolean;
};

const Json: React.FC<Props> = ({ children, value, format = true }) => {
  return (
    <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
      {JSON.stringify(children || value, null, format ? 2 : undefined)}
    </pre>
  );
};

export default Json;
